import type { Document } from './dueDiligence';
import type { CostItem, CostRevision, costSummary } from './purchasePlanning';
import { eur } from './types';

export function hasCostRange(revision: CostRevision | undefined): revision is CostRevision & { low: number; high: number } {
  return revision !== undefined && revision.low !== null && revision.high !== null
    && Number.isFinite(revision.low) && Number.isFinite(revision.high)
    && revision.low >= 0 && revision.high >= revision.low && revision.high <= 100000000;
}

export function costEvidence(item: CostItem, documents: Document[]) {
  const revision = item.revisions.at(-1);
  if (!hasCostRange(revision)) return 'range_missing';
  if (!['quote', 'invoice'].includes(revision.level)) return 'estimate';
  if (!documents.some(document => document.id === revision.documentId)) return 'document_missing';
  if (!revision.locator.trim()) return 'location_missing';
  return 'linked';
}

export const costEvidenceLabels = {
  range_missing: 'Spanne offen', estimate: 'Vorläufige Annahme',
  document_missing: 'Datei fehlt', location_missing: 'Fundstelle fehlt', linked: 'Datei verknüpft',
};
export const costNextActions = {
  range_missing: 'Umfang klären und eine Brutto-Spanne einholen. Eine offene Position ist kein Null-Euro-Betrag.',
  estimate: 'Ein Angebot mit Umfang und Ausschlüssen einholen. Bis dahin bleibt dieser Betrag eine Planungsannahme.',
  document_missing: 'Das zugehörige Angebot oder die Rechnung hochladen und mit diesem Kostenstand verknüpfen.',
  location_missing: 'Die genaue Fundstelle im verknüpften Angebot oder in der Rechnung ergänzen.',
  linked: 'Angebot oder Rechnung ist mit Datei und Fundstelle verknüpft. Umfang, Ausschlüsse und weitere Abhängigkeiten prüfen.',
};

/** A partial range is a lower bound, never a complete upper budget. */
export function costRangeLabel(summary: Pick<ReturnType<typeof costSummary>, 'low' | 'high' | 'known' | 'unknown' | 'total'>, budgetReviewed: boolean) {
  if (!summary.known && (summary.unknown > 0 || !budgetReviewed)) return 'Noch offen';
  if (summary.unknown > 0) return `Ab ${eur(summary.low)} · ${summary.unknown} offen`;
  return summary.low === summary.high ? eur(summary.low) : `${eur(summary.low)} – ${eur(summary.high)}`;
}
